<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-container">
        <div class="modal-header">
          <h3>Acerto de Atendimento</h3>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>Vencimento:</label>
                <input type="date" class="form-control" v-model="dados.vencimento">
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Valor:</label>
                <money ref="valor" class="form-control" v-model="dados.valor" v-bind="money"></money>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <div class="text-right" style="float:right">
            <button class="btn btn-default" @click="$emit('close')">
              <i class="fa fa-close"></i> Fechar
            </button>
            <button class="btn btn-primary" @click="$emit('updateBoleto', dados.boleto_id, dados)">Confirmar</button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import axios from "axios"; // Cliente para requisição http
import { Money } from "v-money";
export default {
  props: ['boletoId'],
  filters: {},
  data: () => ({
    money: {
      decimal: ",",
      thousands: ".",
      prefix: "R$ ",
      precision: 2,
      masked: false
    },
    dados: {
      vencimento: null,
      valor: 0
    }
  }),
  mounted() {
   // this.$refs.valor.focus();
   this.getBoletoById(this.boletoId);
  },
  methods: {
      getBoletoById(boletoId) {
      this.$store.commit("TOGGLE_LOADING");
      axios
        .get(
          `${this.$store.state.serverURI}/api/boleto/getById/${boletoId}`,
          this.$store.getters.getHeaderAuth
        )
        .then(response => {
          this.dados.boleto_id = response.data.id;
          this.dados.vencimento = response.data.vencimento;
          this.dados.valor = response.data.valor;
        });
    },
  },
  
  components: {
    Money
  }
};
</script>

<style scoped>
* {
  box-sizing: border-box;
}

.modal-mask {
  position: fixed;
  z-index: 1001;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  transition: opacity 0.3s ease;
}

.modal-container {
  width: 40%;
  height: auto;
  margin: 60px auto 0;
  padding: 10px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #333;
}

.modal-body {
  height: 250px;
  overflow-y: auto;
}

.text-right {
  text-align: right;
}

.form-label {
  display: block;
  margin-bottom: 1em;
}

.form-label > .form-control {
  margin-top: 0.5em;
}

.form-control {
  display: block;
  width: 100%;
  padding: 0.5em 1em;
  line-height: 1.5;
  border: 1px solid #ddd;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.modal {
  display: block !important;
  /* I added this to see the modal, you don't need this */
}

/* Important part */

.modal-dialog {
  overflow-y: initial !important;
}

.modal-body {
  height: 150px;
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// modalAcertoAtendimento.vue?7122d1ba